import request from "@/utils/request";
// post方法
export function login(data) {
  data.grant_type = "password";
  return request({
    url: "o/token/",
    method: "post",
    data: data,
  });
}

export function logout(data = {}){
  return request({
    url: "logout_erp/",
    method: "post",
    data: data,
  });
}